import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billsFilterHeaderStyle';
import { makeStyles } from '@material-ui/styles';
import { BodyS } from 'components/Typography/Typography';
import { useSelector } from 'react-redux';
import { getBOMLabels } from 'redux/modules/dynamicLabels/selectors';
import AlternativeSelect, { IAlternativeSelectItem } from 'components/AlternativeSelect/AlternativeSelect';
import { BillingPeriod } from './BillingPeriod';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import { ALL, PAID, PENDING, UNPAID } from 'views/Bills/constants';
import moment, { Moment } from 'moment';

// @ts-ignore
const useStyles = makeStyles(styles);
interface ISelectedAccount {
	name: string;
	id: string | null;
}

interface ISelectedBillingId {
	name: string;
	id: string;
}
export type dialogType = 'success' | 'failier' | null;

interface IFilterHeaders {
	setSelectedAccount: Function;
	selectedAccount: ISelectedAccount | null;
	availableAccounts: Array<SingleCorpAccount>;
	setAppliedFilters: Function;
	appliedFilters: types.redux.numbers.MyBillsFilters;
	clearAllTags: Function;
	selectedBillingId: ISelectedBillingId;
	handleElementsSelected: Function;
	billingAccountIds: Array<ISelectedBillingId>;
	selectedBillingAccountId: string[];
}

const FilterHeaders = ({
	setSelectedAccount, //function to set the selected account
	selectedAccount, // value which has selected account
	availableAccounts, // all accounts to be shown in dropdown
	setAppliedFilters, //function to set state of applied filters
	appliedFilters, //variable that stores all the applied filters
	clearAllTags, //function to be called to clear all filters when account is changed
	selectedBillingId, //selected billing id
	handleElementsSelected, //function to be called when billing ids are selected from the drop down
	billingAccountIds, //all billing account ids for a particular organization
	selectedBillingAccountId, //selected billing account ids
}: IFilterHeaders) => {
	const classes = useStyles();
	const [searchValue, setSearchValue] = useState<string>('');
	const [filteredBillingAccountIds, setFilteredBillingAccountIds] = useState<Array<ISelectedBillingId>>(
		billingAccountIds
	);

	const labels = useSelector(getBOMLabels);
	const billsListLabels = labels?.billsListLabels || {};
	useEffect(() => {
		setFilteredBillingAccountIds(billingAccountIds);
	}, [billingAccountIds]);
	useEffect(() => {
		if (searchValue && searchValue.length > 1) {
			let filteredIds = billingAccountIds.filter((accountIds) => accountIds.name.includes(searchValue));
			setFilteredBillingAccountIds(filteredIds);
		} else setFilteredBillingAccountIds(billingAccountIds);
	}, [searchValue]);

	const handleAccounFilterClick = (account: ISelectedAccount) => {
		if (selectedAccount && selectedAccount.id === account.id) {
			setSelectedAccount({
				name: availableAccounts[0].accountName,
				id: availableAccounts[0].accountId,
			});
		} else {
			setSelectedAccount(account);
		}
	};
	const accountList = React.useMemo(() => {
		return availableAccounts.map((account: any) => ({
			name: account.accountName,
			id: account.accountId,
		}));
	}, [availableAccounts]);

	const getSelectedItem = (account: ISelectedAccount | null, billingStatus?: string) => {
		if (billingStatus) return [billingStatus];
		if (account && account.id) {
			return [account.id];
		} else {
			return [availableAccounts[0]?.accountId];
		}
	};

	const billStatus = [
		{ name: ALL, value: ALL, id: '1' },
		{ name: PAID, value: PAID, id: '2' },
		{ name: UNPAID, value: UNPAID, id: '3' },
		{ name: PENDING, value: PENDING, id: '4' },
	];
	return (
		<div className={classes.filtersWrapper}>
			<div className={classes.alternativeSelectWrapper}>
				<AlternativeSelect
					showBorder
					dropdownIcon={<ArrowDropDownIcon />}
					className={classes.selectedItem}
					type="sm"
					id="organization-select"
					label={billsListLabels.organizationFilter}
					value={
						<BodyS disableMargin>
							{(selectedAccount && selectedAccount.name) || availableAccounts[0]?.accountName}
						</BodyS>
					}
					onClick={(account) => {
						setAppliedFilters({ ...appliedFilters, organization: account?.id });
						handleAccounFilterClick(account);
						clearAllTags();
					}}
					items={accountList as Array<string | IAlternativeSelectItem>}
					selectedItems={getSelectedItem(selectedAccount)}
					withHorizontalPadding
				/>
			</div>
			<div className={classes.alternativeSelectWrapper}>
				<AlternativeSelect
					showBorder
					dropdownIcon={<ArrowDropDownIcon />}
					className={classes.selectedItem}
					type="sm"
					id="account-select"
					label={billsListLabels.billingAccountFilter}
					searchOption={true}
					searchValue={searchValue}
					setSearchValue={setSearchValue}
					value={<BodyS disableMargin>{selectedBillingAccountId.length ? selectedBillingId.name : ''}</BodyS>}
					onClick={(account) => {
						handleElementsSelected(account);
						setAppliedFilters({ ...appliedFilters, billingId: account.id });
					}}
					items={filteredBillingAccountIds as Array<string | IAlternativeSelectItem>}
					selectedItems={selectedBillingAccountId}
					withHorizontalPadding
				/>
			</div>
			<div className={classes.alternativeSelectWrapper} id="billing-period">
				<BillingPeriod setAppliedFilters={setAppliedFilters} appliedFilters={appliedFilters} />
			</div>
			<div className={classes.alternativeSelectWrapper}>
				<AlternativeSelect
					showBorder
					dropdownIcon={<ArrowDropDownIcon />}
					className={classes.selectedItem}
					type="sm"
					id="payment-status-select"
					label={billsListLabels.paymentStatusFilter}
					// value={<BodyS disableMargin>{appliedFilters.billingStatus || billsListLabels.all}</BodyS>}
					onClick={(item) => {
						setAppliedFilters({
							...appliedFilters,
							billingStatus: {
								value: item.value,
								name: item.name,
								id: item.id,
							},
						});
					}}
					value={
						<div>
							{appliedFilters.billingStatus.value
								? labels.billsListLabels[appliedFilters.billingStatus.value]
								: labels.billsListLabels.All}
						</div>
					}
					items={
						billStatus.map((status) => {
							return { ...status, name: labels.billsListLabels[status.name] };
						}) as Array<string | IAlternativeSelectItem>
					}
					selectedItems={[appliedFilters.billingStatus.id]}
					withHorizontalPadding
				/>
			</div>
		</div>
	);
};

export default FilterHeaders;
